"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyAdGroupUpdateSchema = exports.AppleProxyAdGroupCreateSchema = exports.AppleProxyAdGroupRefParamsSchema = exports.AppleProxyAdGroupListResponseSchema = exports.AppleProxyAdGroupResponseSchema = exports.AppleProxyAdGroupSchema = exports.AppleProxyTargetingDimensionsSchema = exports.AppleProxyAppCategoryCriteriaSchema = exports.AppleProxyLocalityCriteriaSchema = exports.AppleProxyGenderCriteriaSchema = exports.AppleProxyGenderSchema = exports.AppleProxyDeviceClassCriteriaSchema = exports.AppleProxyDaypartCriteriaSchema = exports.AppleProxyDaypartDetailSchema = exports.AppleProxyCountryCriteriaSchema = exports.AppleProxyAppDownloaderCriteriaSchema = exports.AppleProxyAgeRangeCriteriaSchema = exports.AppleProxyAgeRangeSchema = exports.AppleProxyAdminAreaCriteriaSchema = exports.AppleProxyPricingModelSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const utils_1 = require("../../../utils");
const core_2 = require("./core");
exports.AppleProxyPricingModelSchema = (0, core_1.StringUnion)(["CPC", "CPM"], {
    title: "Pricing Model",
    description: "CPC - The average cost for each ad tap/impression in a campaign. \
    CPM - The cost per 1000 impressions in a campaign. \
    Note: You can't set the parameter when the pricingModel value is CPM.",
});
exports.AppleProxyAdminAreaCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
});
exports.AppleProxyAgeRangeSchema = typebox_1.Type.Object({
    maxAge: (0, core_1.OptionalNullable)(typebox_1.Type.Integer({ maximum: 65 })),
    minAge: (0, core_1.OptionalNullable)(typebox_1.Type.Integer({ maximum: 65 })),
});
exports.AppleProxyAgeRangeCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyAgeRangeSchema)),
});
exports.AppleProxyAppDownloaderCriteriaSchema = typebox_1.Type.Object({
    excluded: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
});
exports.AppleProxyCountryCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
});
exports.AppleProxyDaypartDetailSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.Integer())),
});
exports.AppleProxyDaypartCriteriaSchema = typebox_1.Type.Object({
    userTime: (0, core_1.OptionalNullable)(exports.AppleProxyDaypartDetailSchema),
});
exports.AppleProxyDeviceClassCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(core_2.AppleProxyDeviceClassSchema)),
});
exports.AppleProxyGenderSchema = (0, core_1.StringUnion)(["M", "F"]);
exports.AppleProxyGenderCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyGenderSchema)),
});
exports.AppleProxyLocalityCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
});
exports.AppleProxyAppCategoryCriteriaSchema = typebox_1.Type.Object({
    included: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.Number())),
    excluded: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.Number())),
});
exports.AppleProxyTargetingDimensionsSchema = typebox_1.Type.Object({
    adminArea: (0, core_1.OptionalNullable)(exports.AppleProxyAdminAreaCriteriaSchema),
    age: (0, core_1.OptionalNullable)(exports.AppleProxyAgeRangeCriteriaSchema),
    appCategories: (0, core_1.OptionalNullable)(exports.AppleProxyAppCategoryCriteriaSchema),
    appDownloaders: (0, core_1.OptionalNullable)(exports.AppleProxyAppDownloaderCriteriaSchema),
    country: (0, core_1.OptionalNullable)(exports.AppleProxyCountryCriteriaSchema),
    daypart: (0, core_1.OptionalNullable)(exports.AppleProxyDaypartCriteriaSchema),
    deviceClass: (0, core_1.OptionalNullable)(exports.AppleProxyDeviceClassCriteriaSchema),
    gender: (0, core_1.OptionalNullable)(exports.AppleProxyGenderCriteriaSchema),
    locality: (0, core_1.OptionalNullable)(exports.AppleProxyLocalityCriteriaSchema),
});
const AppleProxyAdGroupServingStateReasonsSchema = typebox_1.Type.String(
// Enum validation may cause issues
// [
//     "AD_GROUP_PAUSED_BY_USER",
//     "ADGROUP_END_DATE_REACHED",
//     "APP_NOT_SUPPORT",
//     "AUDIENCE_BELOW_THRESHOLD",
//     "CAMPAIGN_NOT_RUNNING",
//     "DELETED_BY_USER",
//     "PENDING_AUDIENCE_VERIFICATION",
//     "START_DATE_IN_THE_FUTURE",
// ],
{
    title: "Serving State Reasons",
    description: "Potential reasons for an ad group not running.",
});
const AppleProxyAdGroupServingStateReasonsListSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyAdGroupServingStateReasonsSchema), {
    title: "Serving State Reasons List",
    description: "A list of reasons that displays when an ad group isn't running.",
});
const AppleProxyAutomatedKeywordsOptInSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Boolean(), {
    title: "Automated Keywords Opt In",
    description: "The parameter for enabling and disabling Search Match. If true, the system automatically adds optimized keywords in addition to those you explicitly add to the ad group.",
});
const AppleProxyCampaignRefSchema = (0, utils_1.extendIntegerType)(ruby_1.AppleProxyRefSchema, {
    title: "ID",
    description: "The unique identifier for the campaign.",
});
const AppleProxyCpaGoalSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Object(ruby_1.AppleProxyMoneySchema.properties), {
    title: "CPA Goal",
    description: "The cost-per-acquisition goal.",
});
const AppleProxyDefaultBidAmountSchema = typebox_1.Type.Object(ruby_1.AppleProxyMoneySchema.properties, {
    title: "Default Bid Amount",
    description: "The default maximum cost per tap/impression bid for the ad group.",
});
const AppleProxyDeletedSchema = (0, core_1.OptionalNullable)(typebox_1.Type.Boolean(), {
    title: "Deleted",
    description: "The indicator of whether the ad group is soft-deleted. This includes keywords that belong to an ad group.",
});
const AppleProxyAdGroupDisplayStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDisplayStatusSchema, {
    title: "Display Status",
    description: "The status of the ad group. The status resolves according to servingStatus and additional criteria.",
});
const AppleProxyAdGroupEndTimeSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema, {
    title: "End Time",
    description: "The scheduled end date and time for the ad group, which the system determines from the ad group with the latest end time.",
});
const AppleProxyAdGroupRefSchema = (0, utils_1.extendIntegerType)(ruby_1.AppleProxyRefSchema, {
    description: "The unique identifier for the ad group that you can use as adGroupId in endpoint resources.",
});
const AppleProxyAdGroupName = typebox_1.Type.String({
    title: "Name",
    description: "The unique name of the ad group. Responses don’t include deleted ad groups.",
});
const AppleProxyAdGroupServingStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyServingStatusSchema, {
    title: "Serving Status",
    description: "The status of whether the ad group is serving.",
});
const AppleProxyAdGroupStartTimeSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema, {
    title: "Start Time",
    description: "The scheduled start date and time for the ad group with the earliest start time in the campaign.",
});
const AppleProxyAdGroupStatusSchema = (0, core_1.OptionalNullable)(core_2.AppleProxyStatusSchema, {
    title: "Status",
    description: "The user-controlled status to enable or pause the ad group.",
});
const AppleProxyAdGroupTargetingDimensions = (0, core_1.OptionalNullable)(exports.AppleProxyTargetingDimensionsSchema, {
    title: "Targeting Dimensions",
    description: "The targeting criteria to narrow the audience. Targeting options include age, gender, geolocation, daypart, device, and app downloaders.",
});
exports.AppleProxyAdGroupSchema = typebox_1.Type.Object({
    automatedKeywordsOptIn: AppleProxyAutomatedKeywordsOptInSchema,
    campaignId: (0, core_1.OptionalNullable)(AppleProxyCampaignRefSchema),
    cpaGoal: AppleProxyCpaGoalSchema,
    defaultBidAmount: AppleProxyDefaultBidAmountSchema,
    deleted: AppleProxyDeletedSchema,
    displayStatus: AppleProxyAdGroupDisplayStatusSchema,
    endTime: AppleProxyAdGroupEndTimeSchema,
    id: AppleProxyAdGroupRefSchema,
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyModificationTimeSchema),
    name: AppleProxyAdGroupName,
    orgId: ruby_1.AppleProxyOrgRefSchema,
    pricingModel: exports.AppleProxyPricingModelSchema,
    servingStateReasons: AppleProxyAdGroupServingStateReasonsListSchema,
    servingStatus: AppleProxyAdGroupServingStatusSchema,
    startTime: AppleProxyAdGroupStartTimeSchema,
    status: AppleProxyAdGroupStatusSchema,
    targetingDimensions: AppleProxyAdGroupTargetingDimensions,
});
exports.AppleProxyAdGroupResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyAdGroupSchema),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyApiErrorResponseSchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyAdGroupListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxyAdGroupSchema)),
    error: (0, core_1.OptionalNullable)(core_2.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyAdGroupRefParamsSchema = typebox_1.Type.Object({
    id: ruby_1.AppleProxyRefSchema,
    adGroupId: ruby_1.AppleProxyRefSchema,
});
exports.AppleProxyAdGroupCreateSchema = typebox_1.Type.Object({
    automatedKeywordsOptIn: AppleProxyAutomatedKeywordsOptInSchema,
    campaignId: (0, core_1.OptionalNullable)(AppleProxyCampaignRefSchema),
    cpaGoal: AppleProxyCpaGoalSchema,
    defaultBidAmount: AppleProxyDefaultBidAmountSchema,
    deleted: AppleProxyDeletedSchema,
    endTime: AppleProxyAdGroupEndTimeSchema,
    name: AppleProxyAdGroupName,
    orgId: ruby_1.AppleProxyOrgRefSchema,
    pricingModel: exports.AppleProxyPricingModelSchema,
    startTime: AppleProxyAdGroupStartTimeSchema,
    status: AppleProxyAdGroupStatusSchema,
    targetingDimensions: AppleProxyAdGroupTargetingDimensions,
});
exports.AppleProxyAdGroupUpdateSchema = typebox_1.Type.Object({
    automatedKeywordsOptIn: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    cpaGoal: typebox_1.Type.Optional(ruby_1.AppleProxyMoneySchema),
    defaultBidAmount: typebox_1.Type.Optional(ruby_1.AppleProxyMoneySchema),
    endTime: typebox_1.Type.Optional(core_2.AppleProxyDateTimeSchema),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    startTime: typebox_1.Type.Optional(core_2.AppleProxyDateTimeSchema),
    status: typebox_1.Type.Optional(core_2.AppleProxyStatusSchema),
    targetingDimensions: typebox_1.Type.Optional(exports.AppleProxyTargetingDimensionsSchema),
});
